export let ApiSetting = {
  DEFAULT_HOST: `${process.env.REACT_APP_API_HOST}`,
  DEFAULT_BASE_PATH: "/api/v1",
};
